import { StyleSheet } from 'react-native';

export const MAX_WIDTH = 850;

export const styles = StyleSheet.create({
  layoutChildrenContainer: {
    maxWidth: MAX_WIDTH,
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 24,
    overflow: 'hidden',
  },
});
